/**
 * Created by Ning Jiang on 10/3/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {NudgeStackedSymbolWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/nudge/NudgeStackedSymbolWPController";
import {TombstoneMultiplierController} from "../../multiplier/TombstoneMultiplierController";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneWildSymbol} from "../../symbols/TombstoneWildSymbol";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";

export class NudgeWildWPController extends NudgeStackedSymbolWPController {

    constructor(indexes:[number, number]) {
        super(indexes, {nudgeStepSpeed : 0.6, stackedSymbolKeyword : "W"});
    }

    protected isNoWinNudge(data:TombstoneParsedGameData):boolean {
        if(data.mode === GameMode.NORMAL && data.nextMode != GameMode.RESPIN) {
            return super.isNoWinNudge(data);
        }
        return false;
    }

    protected playNudgeStepStart(stepsLeft:number):void {
        const step:number = Math.abs(stepsLeft);
        if(step > 0) {
            SlotGame.sound.playEffect(step > 1 ? TombstoneSoundConfig.instance.NUDGE : TombstoneSoundConfig.instance.NUDGE_END);
        }
    }

    protected playOnNudgeStepComplete(reelId:number, stepsLeft:number):void {
        if(!this._noWinNudge) {
            // the middle symbol is always Wild
            const wild:TombstoneWildSymbol = <TombstoneWildSymbol>Reels.getSymbol(reelId, 1);
            if(wild) {
                (<TombstoneWildSymbol[]>wild.stack!.symbols).forEach((symbol:TombstoneWildSymbol) => {
                    symbol.updateMultiplier(Math.abs(this._nudgedSteps[reelId]) + 1, true);
                });
            }
            EventHandler.dispatchEvent(new GameEvent(TombstoneMultiplierController.ADD_MULTIPLIER));
        }
    }

    protected playOnReelNudgeComplete(reelId:number, aborted:boolean):void {
        if(this._noWinNudge) {
            // the middle symbol is always Wild
            const wild:TombstoneWildSymbol = <TombstoneWildSymbol>Reels.getSymbol(reelId, 1);
            if(wild) {
                (<TombstoneWildSymbol[]>wild.stack!.symbols).forEach((symbol:TombstoneWildSymbol) => {
                    symbol.updateMultiplier(Math.abs(this._nudgedSteps[reelId]) + 1, false);
                });
            }

            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.NUDGE_NO_WIN);
        }
    }

    protected abortNudgingReel(reelId:number):void {
        super.abortNudgingReel(reelId);

        const symbolId:number = this._steps[reelId] >= 0 ? 0 : 2;
        const wild:TombstoneWildSymbol = <TombstoneWildSymbol>Reels.getSymbol(reelId, symbolId);
        if(wild) {
            (<TombstoneWildSymbol[]>wild.stack!.symbols).forEach((symbol:TombstoneWildSymbol) => {
                symbol.updateMultiplier(Math.abs(this._steps[reelId]) + 1, true, "normal");
            });
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);

        EventHandler.dispatchEvent(new GameEvent(TombstoneMultiplierController.SHOW_END_MULTIPLIER, isAborted && !this._noWinNudge));
    }

    protected playNudgeAbortSound():void {
        SlotGame.sound.playEffect(TombstoneSoundConfig.instance.NUDGE_END);
    }
}